export const FIR_AUTOFILL_DATA = "FIR_AUTOFILL_DATA";
export const CORPORATE_AUTOFILL_DATA = "CORPORATE_AUTOFILL_DATA";